export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/b2b-bubble.2d3c03d8-425dfc.svg";